module.exports = __webpack_public_path__ + "static/side-img-6-db5ca54ddb5c6187d8a7df22a41be046.png";